import { IconBan as TablerIconBan } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconBan = /*#__PURE__*/ createOutlineIcon(TablerIconBan, 'IconBan');
